<template>
    <section class="section is-medium">
        <div class="container">
            <div class="columns is-gapless upper-panel">
                <div class="column">
                    <section class="section">
                        <div class="container cover-text">
                            <h2 class="titles is-size-2 is-size-4-mobile">Contáctanos</h2>
                            <br>
                            <div class="is-size-4-desktop is-size-5-mobile">
                                <p>Loma Camino Real #257, Loma Bonita, Tonalá, C.P. 45405</p>
                                <p>33 1793-8321</p>
                                <p>contacto@mision-agape.com</p>
                            </div>
                            <section class="section">
                                <MediaCotnact whitened=True></MediaCotnact>
                            </section>
                        </div>
                    </section>
                </div>
                <div class="column map">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3733.4731520704627!2d-103.25659423453546!3d20.650320786204603!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8428b412a5f71f59%3A0x4c6f934e37edb36e!2sCalle%20Loma%20Camino%20Real%20257%2C%20Loma%20Bonita%2C%2045416%20Tonal%C3%A1%2C%20Jal.!5e0!3m2!1ses-419!2smx!4v1599097657064!5m2!1ses-419!2smx" width="100%" height="100%" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import MediaCotnact from '@/components/MediaContact.vue'

export default {
    name: 'Contact',
    components: {
        MediaCotnact
    }
}
</script>

<style lang="scss" scoped>
    .map {
        background-color: white;
    }

    .over-text {
        color: white;
    }
</style>